<template>
  <a-drawer width="80%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="类型" prop="type">
        <a-select v-model="form.type" placeholder="请选择类型" :disabled="formType === 2">
          <a-select-option :value="0">周会员</a-select-option>
          <a-select-option :value="1">月会员</a-select-option>
          <a-select-option :value="2">年会员</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="每天单价" prop="unitPrice">
        <a-input-number :min="0" :step="0.01" :precision="2" v-model="form.unitPrice" placeholder="请输入每天单价" style="width: 100%" />
      </a-form-model-item>
      <a-form-model-item label="总价" prop="totalPrice">
        <a-input-number :min="0" :step="0.01" :precision="2" v-model="form.totalPrice" placeholder="请输入总价" style="width: 100%" />
      </a-form-model-item>
      <a-form-model-item label="划线价" prop="crossedPrice">
        <a-input-number :min="0" :step="0.01" :precision="2" v-model="form.crossedPrice" placeholder="请输入划线价" style="width: 100%" />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getMenu, addMenu, updateMenu } from '@/api/vip/menu'

export default {
  name: 'CreateForm',
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      form: {
        id: null,
        type: null,
        unitPrice: null,
        productId: null,
        totalPrice: null,
        crossedPrice: null,
        isOpen: 1,
        createTime: null
      },
      formType: 1,
      open: false,
      rules: {
        type: [
          { required: true, message: '请选择会员类型', trigger: 'change' }
        ],
        unitPrice: [
          { required: true, message: '每天单价不能为空', trigger: 'blur' }
        ],
        totalPrice: [
          { required: true, message: '总价不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    onClose () {
      this.open = false
    },
    cancel () {
      this.open = false
      this.reset()
    },
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        type: null,
        unitPrice: null,
        productId: null,
        totalPrice: null,
        crossedPrice: null,
        isOpen: 1,
        createTime: null
      }
      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.resetFields()
        }
      })
    },
    handleAdd () {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '新增会员菜单'
    },
    handleUpdate (row) {
      this.reset()
      this.formType = 2
      getMenu({ id: row.id }).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = '修改会员菜单'
      })
    },
    submitForm () {
      this.$refs.form.validate(valid => {
        if (!valid) {
          return false
        }
        this.submitLoading = true
        const request = this.form.id != null ? updateMenu(this.form) : addMenu(this.form)
        request.then(() => {
          this.$message.success(this.form.id != null ? '修改成功' : '新增成功')
          this.open = false
          this.$emit('ok')
        }).finally(() => {
          this.submitLoading = false
        })
      })
    }
  }
}
</script>
